module.exports = __webpack_public_path__ + "img/img106.ce31f2a6.svg";